import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Nav,
  NavContainer,
  Logo,
  LogoImage,
  NavLinks,
  NavLink,
  MobileMenuButton,
  MobileMenu,
  MobileNavLink
} from './styles';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <Nav>
      <NavContainer>
        <Logo to="/">
          <LogoImage viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(100, 100)">
              <circle cx="0" cy="0" r="70" fill="none" stroke="#3b82f6" strokeWidth="3"/>
              <path d="M-50,-50 Q-30,-70 0,-70 Q30,-70 50,-50" 
                    fill="none" 
                    stroke="rgba(255,255,255,0.8)" 
                    strokeWidth="1"/>
              <rect x="-40" y="60" width="80" height="25" rx="5" fill="#1e40af"/>
              <rect x="-30" y="85" width="60" height="10" rx="3" fill="#1e40af"/>
              <rect x="-8" y="0" width="16" height="60" fill="#3b82f6"/>
              <circle cx="0" cy="0" r="12" fill="#ec4899"/>
            </g>
          </LogoImage>
          Core Plasma
        </Logo>
        <NavLinks>
          <NavLink to="/" className={isActive('/') ? 'active' : ''}>
            Home
          </NavLink>
          <NavLink to="/about" className={isActive('/about') ? 'active' : ''}>
            About
          </NavLink>
          <NavLink to="/services" className={isActive('/services') ? 'active' : ''}>
            Services
          </NavLink>
          <NavLink to="/patents" className={isActive('/patents') ? 'active' : ''}>
            Patents
          </NavLink>
          <NavLink to="/contact" className={isActive('/contact') ? 'active' : ''}>
            Contact
          </NavLink>
        </NavLinks>
        <MobileMenuButton onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </MobileMenuButton>
      </NavContainer>
      <MobileMenu isOpen={isOpen}>
        <MobileNavLink to="/" onClick={() => setIsOpen(false)}>
          Home
        </MobileNavLink>
        <MobileNavLink to="/about" onClick={() => setIsOpen(false)}>
          About
        </MobileNavLink>
        <MobileNavLink to="/patents" onClick={() => setIsOpen(false)}>
          Patents
        </MobileNavLink>
        <MobileNavLink to="/contact" onClick={() => setIsOpen(false)}>
          Contact
        </MobileNavLink>
      </MobileMenu>
    </Nav>
  );
};

export default Navigation; 